import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var ErrorAlert = function (props) {
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M12 1.125L23.25 21H0.75L12 1.125ZM12.0079 18.75C12.4489 18.75 12.9214 18.2381 12.9214 17.6332C12.9214 16.9969 12.4489 16.5 12.0079 16.5C11.4563 16.5 11.0782 16.9969 11.0782 17.6332C11.0786 18.2381 11.4566 18.75 12.0079 18.75ZM12.375 15.375C12.375 15.375 12.7031 12.9874 12.75 12.186C12.8182 11.0182 12.75 7.5075 12.75 7.5075H11.25C11.25 7.5075 11.1818 11.0182 11.25 12.186C11.2969 12.9874 11.625 15.375 11.625 15.375H12.375Z",
    fill: "currentColor"
  }));
};
export { ErrorAlert as default };
//# sourceMappingURL=ErrorAlert.js.map
